// src/belediye/components/utils/dateTime.js

export function parseDateMaybe(value) {
  if (!value) return null;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  return d;
}

/**
 * "12 Oca 2026"
 */
export function formatDateTr(value, opts = {}) {
  const d = parseDateMaybe(value);
  if (!d) return "—";

  const { timeZone = "Europe/Istanbul" } = opts;

  return new Intl.DateTimeFormat("tr-TR", {
    timeZone,
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).format(d);
}

/**
 * "12 Oca 2026 • 14:35"
 */
export function formatDateTimeTr(value, opts = {}) {
  const d = parseDateMaybe(value);
  if (!d) return "—";

  const {
    timeZone = "Europe/Istanbul",
    withSeconds = false,
    separator = " • ",
  } = opts;

  const datePart = new Intl.DateTimeFormat("tr-TR", {
    timeZone,
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).format(d);

  const timePart = new Intl.DateTimeFormat("tr-TR", {
    timeZone,
    hour: "2-digit",
    minute: "2-digit",
    ...(withSeconds ? { second: "2-digit" } : {}),
  }).format(d);

  return `${datePart}${separator}${timePart}`;
}
